import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  ViewChild,
} from "@angular/core";
import { NgxSmartModalService } from "ngx-smart-modal";
import * as moment from "moment";
import { PrintFolders } from "../../Model/print-folders";
import { UdcServiceService } from "../../Services/udc-service.service";
import { UserDefinedCodes } from "../../Model/user-defined-codes";
import {
  IComboSelectionChangeEventArgs,
  IgxComboComponent,
} from "igniteui-angular";
import { PrintQueueService } from "../../Services/print-queue.service";
import { NgxSpinnerService } from "ngx-spinner";
import { Router } from "@angular/router";

@Component({
  selector: "print-folder-list",
  templateUrl: "./print-folder-list.component.html",
  styleUrls: ["./print-folder-list.component.css"],
})
export class PrintFolderListComponent implements OnInit {
  @Input()
  items: PrintFolders[];

  public columnDefs = [];
  public rowData = [];
  public days: UserDefinedCodes[] = [];
  private gridApi;
  private gridColumnApi;
  private gridOptions;
  private defaultColDef;
  private rowSelection;
  private detailCellRendererParams;
  private selectedDays: number;
  private selection = [];
  private selectionIndex = 0;

  constructor(
    private udcService: UdcServiceService,
    private service: PrintQueueService,
    private spinner: NgxSpinnerService,
    private router: Router
  ) {
    this.defaultColDef = { sortable: true, filter: true };
    this.rowSelection = "single";
    this.createGridColumnDefs();
  }

  createGridColumnDefs() {
    this.columnDefs = [
      {
        headerName: "Path",
        field: "pathName",
        filter: "agTextColumnFilter",
        width: 400,
        cellRenderer: function (params) {
          if (params.data.objectType == "*STMF") {
            let lastIndex = String(params.data.pathName).lastIndexOf("/");
            let path =
              String(params.data.pathName).substring(0, lastIndex) + "/";
            let fileName = String(params.data.pathName).substring(
              lastIndex + 1
            );
            let url =
              "<a href=https://data.kinghickoryb2b.com:8081/salesReporting/api/download/report?path=" +
              path +
              "&fileName=" +
              encodeURI(fileName) +
              " target=_blank>" +
              params.value +
              "</a>";
            return url;
          } else return params.data.pathName;
        },
      },
      {
        headerName: "Type",
        field: "objectType",
        filter: false,
        width: 50,
      },
      {
        headerName: "Creation Date/Time",
        field: "creationDateTime",
        filter: false,
        width: 115,
      },
      {
        headerName: "Last Date/Time",
        field: "lastDateTime",
        filter: false,
        width: 115,
      },
      {
        headerName: "Size",
        field: "dataSize",
        filter: false,
        type: "numericColumn",
        width: 50,
      },
    ];
  }

  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    params.api.sizeColumnsToFit();
  }

  onBackClick() {
    this.router.navigate(["/sales/b2bLanding"]);
  }

  onSelectionChanged(event) {}

  ngOnInit() {}
}
